import { type Event, getCurrentUserRole, getCurrentUserRsvp } from 'models';
import { useUser } from 'features/auth';
import { EventActions } from '../../components';

type P = {
  event: Event;
};

const EventRsvpStatus = ({ event }: P) => {
  const { participants, status } = event;
  const { nodeUserData: nodeViewer } = useUser();
  const currentUserRsvp = getCurrentUserRsvp({ participants, viewerId: nodeViewer._id });
  const currentUserRole = getCurrentUserRole({ participants, viewerId: nodeViewer._id });

  if (
    status === 'draft' ||
    status === 'canceled' ||
    !currentUserRsvp ||
    !currentUserRole ||
    currentUserRsvp === 'pending'
  ) {
    return null;
  }

  return (
    <EventActions
      event={{ ...event, role: currentUserRole, rsvp: currentUserRsvp }}
      type="link-secondary"
      view="header"
    />
  );
};

export default EventRsvpStatus;
